export enum PetType {
  Dog = "dog",
  Cat = "cat",
}

export enum CoverType {
  Top = "top",
  Custom = "custom",
}

export interface IPet {
  id: string,
  pet_no: number;
  petType: PetType;
  petTypeIndex: number;
  petOrdinalName: string;
  name: string;
  breed?: string;
  petDOB?: string;
  petAgeCategory?: number;
  petAgeOnStartDatePolicy?: number;
  startDate?: string;
  petSex?: string;
  isDesexed?: boolean;
  promoCode?: string;
  coverType?: CoverType;
  isShowedPopup?: boolean;
  customCover?: {
    benefitPercentage?: string;
    annualBenefitLimit?: string;
    annualExcess?: string;
    optionalExtras?: string;
    paymentFrequency?: string;
    vetConsultationFees?: string;
    quoteNumber?: string;
    parentQuoteNumber?: string;
    installmentAmount?: number;
    totalInstallmentBeforeDiscount?: number;
    totalInstallmentAfterDiscount?: number;
    totalInstallmentDiscountAmount?: number;
    quotationSyncId?: number;
    promoCode?: string;
    promotionDetail?: any;
    premiums?: any;
    promo?: any;
  };
  topCover?: {
    paymentFrequency?: string;
    quoteNumber?: string;
    parentQuoteNumber?: string;
    installmentAmount?: number;
    totalInstallmentBeforeDiscount?: number;
    totalInstallmentAfterDiscount?: number;
    quotationSyncId?: number;
    promotionDetail?: any;
  };
  isTouched?: boolean;
  isValid?: boolean;
  pet_refs?: any;
}

export interface PetOwner { }

export type Pets = Array<IPet>;
